import AppInputField from "components/shared/FormComponents/AppInputField";
import { AppSelect2Field } from "components/shared/FormComponents/AppSelect2Field";
import AppSelectField from "components/shared/FormComponents/AppSelectField";
import { useFormikContext } from "formik";
import { replacePlaceholders, userFullName } from "helpers/common";
import moment from "moment";
import { Col, Row } from "react-bootstrap";
import { useGetFormalAssessmentsQuery } from "store/services/utility";
import { store } from "store/store";

const QuestionWithDD = ({ question, fieldName, ...props }) => {
  const { setFieldValue } = useFormikContext();
  const { data: formalAssessments } = useGetFormalAssessmentsQuery();
  const formalAssessmentTitles = formalAssessments?.length
    ? formalAssessments.map(item => ({ value: item.title, label: item.title, description: item.description }))
    : [];
  const ddLabels = question.question_dd_labels;

  const user = store.getState()?.auth?.user;

  return (
    <div className="border rounded-3 p-3">
      <div className="py-1">
        <Row className="align-items-center">
          <Col lg="4">
            <h6 className="m-0 fw-sbold themeBlue pb-2">
              {ddLabels?.length > 0 && ddLabels[0]}:
            </h6>
          </Col>
          <Col lg="8">
            <div
              className="p-2 rounded"
              style={{ background: "#F8F8F8" }}
            >
              <AppSelect2Field
                name={`${fieldName}.other_details.dd_labels.name`}
                option={formalAssessmentTitles}
                onChange={(selected) => {
                  setFieldValue(`${fieldName}.other_details.dd_labels.description`, replacePlaceholders(selected.description, {
                    "DATE": moment().format("DD/MM/YYYY"),
                    "CLINICIAN_NAME": userFullName(user)
                  }))
                }}
              />
            </div>
          </Col>
        </Row>
      </div>
      <div className="py-1">
        {props?.value?.other_details?.dd_labels?.description && (
          <>
            <h6 className="m-0 fw-sbold themeBlue pb-1">
              {ddLabels?.length > 0 && ddLabels[1]}:
            </h6>
            <div
              style={{ background: "#F8F8F8" }}
              className="p-3 rounded mb-3"
            >
              {props?.value?.other_details?.dd_labels?.description}

            </div>
          </>
        )}
        <AppInputField
          name={`${fieldName}.answer`}
          placeholder={question.placeholder}
          fieldType={"textarea"}
          rows={4}
          className="form-control rounded-3 bg-white is-resizable-textarea"
        />
      </div>
    </div>
  )
}

export default QuestionWithDD;